import turfBbox from "@turf/bbox";

class LayersControl {
  constructor({
    layers,
    className = "",
    layersContainerClassName = "",
    titleClassName = "",
    layersListClassName = "",
    layerClassName = "",
  }) {
    this._layers = layers;
    this._className = className;
    this._layersContainerClassName = layersContainerClassName;
    this._titleClassName = titleClassName;
    this._layersListClassName = layersListClassName;
    this._layerClassName = layerClassName;
    this._collapsed = true;
  }

  updateLayers(layers) {
    this._layers = layers;
  }

  renderLayers(container, map) {
    const layersContainer = document.createElement("div");
    layersContainer.className = `${
      this._layersContainerClassName ? this._layersContainerClassName : ""
    }`;

    const titleContainer = document.createElement("div");
    titleContainer.textContent = "Layers";
    titleContainer.className = `${
      this._titleClassName ? this._titleClassName : ""
    }`;

    const layersListContainer = document.createElement("div");
    layersListContainer.className = `${
      this._layersListClassName ? this._layersListClassName : ""
    }`;
    layersListContainer.style.overflow = "auto";
    layersListContainer.style.maxHeight = "50vh";

    if (Array.isArray(this._layers) && this._layers.length > 0) {
      this._layers.forEach((l) => {
        try {
          const layer = map.getLayer(l.id);
          const layerContainer = document.createElement("div");

          const visibilityProp = map.getLayoutProperty(layer.id, "visibility");
          const isVisible = !!(!visibilityProp || visibilityProp === "visible");
          layerContainer.className = `${
            this._layerClassName ? this._layerClassName : ""
          }`;

          if (!isVisible) {
            layerContainer.setAttribute("disabled", "disabled");
          }

          const left = document.createElement("div");
          left.textContent = l.id;
          left.className = "text-truncate";
          left.style.maxWidth = "150px";
          left.setAttribute("title", l.id);
          const right = document.createElement("div");
          const visibleBtn = document.createElement("button");
          visibleBtn.innerHTML = `<i aria-hidden="true" title="Show/hide layer" class="v-icon notranslate mdi ${
            isVisible ? "mdi-eye" : "mdi-eye-off"
          }" style="vertical-align:middle; color:black"></i>`;
          visibleBtn.onclick = () => {
            const visibilityProp = map.getLayoutProperty(
              layer.id,
              "visibility"
            );
            const isVisible = !!(
              !visibilityProp || visibilityProp === "visible"
            );

            if (isVisible) {
              map.setLayoutProperty(layer.id, "visibility", "none");
              layerContainer.setAttribute("disabled", "disabled");
            } else {
              map.setLayoutProperty(layer.id, "visibility", "visible");
              layerContainer.removeAttribute("disabled");
            }

            visibleBtn.innerHTML = `<i aria-hidden="true" title="Show/hide layer" class="v-icon notranslate mdi ${
              isVisible ? "mdi-eye-off" : "mdi-eye"
            }" style="vertical-align:middle; color:black"></i>`;
          };

          right.appendChild(visibleBtn);

          if (map.getSource(layer.source)._data) {
            const zoomToBtn = document.createElement("button");
            zoomToBtn.innerHTML = `<i aria-hidden="true" title="Zoom to layer" class="v-icon notranslate mdi mdi-map-marker" style="vertical-align:middle; color:black"></i>`;
            zoomToBtn.style.border = "none";
            zoomToBtn.onclick = () => {
              const source = map.getSource(layer.source)._data;
              const bounds = turfBbox(source);
              map.fitBounds(bounds, { padding: 200 });
            };
            right.appendChild(zoomToBtn);
          }

          right.style.display = "flex";
          right.style.marginLeft = "0.5rem";
          layerContainer.appendChild(left);
          layerContainer.appendChild(right);
          layersListContainer.appendChild(layerContainer);
        } catch (err) {
          console.error(err);
        }
      });
    } else {
      const noContent = document.createElement("div");
      noContent.textContent = "No layers";
      layersListContainer.appendChild(noContent);
    }

    layersContainer.append(titleContainer);
    layersContainer.append(layersListContainer);
    container.innerHTML = "";
    container.append(layersContainer);
  }

  onAdd(map) {
    // eslint-disable-next-line
    const me = this;
    me._map = map;

    const layersBtn = document.createElement("button");
    layersBtn.innerHTML = `<i aria-hidden="true" title="Show Layers" class="v-icon notranslate mdi mdi-layers" style="vertical-align:middle; color:black"></i>`;
    me._layersBtn = layersBtn;

    const container = document.createElement("div");
    me._container = container;
    container.className = `mapboxgl-ctrl-group mapboxgl-ctrl ${
      me._className ? me._className : ""
    }`;

    container.onmouseenter = () => {
      if (me._collapsed) {
        me.renderLayers(container, map);
        me._collapsed = false;
      }
    };

    container.onmouseleave = () => {
      container.innerHTML = "";
      container.appendChild(layersBtn);
      me._collapsed = true;
    };

    container.appendChild(layersBtn);

    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default LayersControl;
